<template>
  <v-card>
    <v-card-title primary-title>
      <span class="headline mb-0">P/O</span>
    </v-card-title>
    <v-data-table :headers="headers" :items="results" :loading="loading" hide-actions item-key="id">
      <template slot="items" slot-scope="props">
        <td :style="diffStyle('poNo')">{{ props.item.poNo }}</td>
        <td
          :style="diffStyle('partnerCode')"
        >{{ props.item.partnerCode }}:{{ props.item.partnerName }}</td>
        <td :style="diffStyle('buCode')">{{ props.item.buCode }}:{{ props.item.buName }}</td>
        <td
          :style="diffStyle('departmentCode')"
        >{{ props.item.departmentCode }}{{ props.item.departmentName }}</td>
        <td
          :style="diffStyle('productCode')"
        >{{ props.item.productCode}}:{{ props.item.productName}}</td>
        <td :style="diffStyle('skuCode')">{{ props.item.skuCode }}</td>
        <td :style="diffStyle('qty')">{{ props.item.qty }}</td>
        <td :style="diffStyle('qty')">{{ props.item.createdInvoice }}</td>
        <td :style="diffStyle('qty')">{{ props.item.finishedQty }}</td>
        <td :style="diffStyle('currencyCode')">{{ props.item. currencyCode}}</td>
        <td :style="diffStyle('unitPrice')">{{ props.item.unitPrice }}</td>
        <td :style="diffStyle('status')">{{ status[props.item.status] }}</td>
        <td>{{ props.item.handleStatus }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: ['id'],
  data() {
    return {
      form: {},
      status: {
        NORMAL: '',
        CONFLICT: 'PO变更',
        CANCEL: 'PO取消',
        MERGED: 'PO合并'
      },
      headers: [
        { text: 'P/O NO', value: 'poNo', sortable: false },
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: '事業本部', value: 'buName', sortable: false },
        { text: '事業部', value: 'departmentName', sortable: false },
        { text: '品種', value: 'productName', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        //{ text: '社内品番', value: 'skuInnerCode', sortable: false },
        //{ text: '社外品番', value: 'skuOuterCode', sortable: false },
        { text: '発注数量', value: 'qty', sortable: false },
        { text: 'INV作成済', value: 'createdInvoice', sortable: false },
        { text: 'S/A済数', value: 'finishedQty', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: '発注単価', value: 'unitPrice', sortable: false },
        { text: 'PO変更・取消', value: 'poOperating', sortable: false },
        { text: '処理Status', value: 'handleStatus', sortable: false }
      ],
      results: [],
      loading: false
    }
  },
  mounted() {
    this.loading = true
    this.$http.get(`/purchase-orders/conflict?id=${this.id}`).then(res => {
      this.results = res.data
      this.loading = false
      this.$emit('conflict', this.conflictFields, this.newUnitPrice)
    })
  },
  methods: {
    diffStyle(prop) {
      if (this.conflictFields.indexOf(prop) !== -1)
        return 'color: red; font-weight: bold; font-size: 16px'
      return ''
    }
  },
  computed: {
    conflictFields() {
      var checkFields = ['qty', 'unitPrice', 'status']
      if (this.results && this.results.length >= 2) {
        return [
          ...['poNo'],
          ...checkFields.filter(field => {
            return (
              this.results[0][field] &&
              this.results[1][field] &&
              this.results[0][field] !== this.results[1][field]
            )
          })
        ]
      }
      return []
    },
    newUnitPrice() {
      if (this.results && this.results.length >= 2) {
        if (this.results[0].unitPrice !== this.results[1].unitPrice) {
          return this.results.find(p => p.status === 'CONFLICT').unitPrice
        }
      }
      return null
    }
  }
}
</script>

